export const environment = {
  appUrl: 'https://legalad.pulte.com/',
  apiUrl: 'https://legaladapi.pulte.com/odata/',
  applicationInsights: {
    instrumentationKey: '0fb7716f-a6e8-4e94-9d8f-0810cca3617e'
  },
  azureAuthProvider: {
    clientId: '2af65a39-9d62-4582-8263-62acad1d18fb',
    tenant: '1a9277a3-ef66-41f6-96b5-c5390ee468a7'
  },
    envName: 'prod',
  production: true
};
